export function filterObject<T>(obj: T, filterValues: string[]) {
  if (!Object.keys(obj).length) return {};

  return Object.values(obj).reduce((acc: Object, cur, i) => {
    if (!filterValues.includes(cur)) {
      acc[Object.keys(obj)[i]] = cur;
    }

    return acc;
  }, {});
}
